export const fetchAdministrativeDashboardMapInfoUrl = `/dashboard/mapinfo`;
export const fetchAdministrativeDashboardAreasUrl = `/dashboard/filters`;
export const fetchAdministrativeDashboardNotificationsUrl = `/dashboard/notifications`;
export const fetchAdministrativeDashboardSalesUrl = `/dashboard/sales`;
export const fetchAdministrativeDashboardSessionsLastWeekUrl = `/dashboard/sessions/lastweek`;
export const fetchAdministrativeDashboardSessionsTodayUrl = `/dashboard/sessions/today`;
